<template>
    <Modal :show="modalOpen" :closable="!isLoading" @close="close" custom_dialog_css="max-width: 600px;">
        <div slot="header">
            <div class="modal-header">
                <h5 class="modal-title">{{ $t('ceremony.new_ceremony') }}</h5>
                <button
                    type="button"
                    class="close"
                    @click="close"
                    aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>

        <div slot="body">
            <div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>

            <CeremonyForm v-if="formData" v-model="formData" :disabled="isLoading" :errors="formErrors" />
        </div>

        <div slot="footer">
            <button type="button" :disabled="isLoading" class="btn btn-primary btn-icon btn-sm" @click="createCeremony">
                {{ $t('general.create') }}
            </button>

            <button type="button" :disabled="isLoading" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="close">
                {{ $t('general.close') }}
            </button>
        </div>
    </Modal>
</template>

<script setup>
    import Modal from '../../components/Modal.vue';
    import { onMounted, ref } from 'vue';
    import { ipcCall, IpcCall } from '../utils/ipcCall';
    import CeremonyForm from '../../components/CeremonyForm.vue';
    import { STATE } from '../../enums/state';
    import store from '../../store/store';
    import i18n from "../../utils/locale";
    import { notifySuccess } from '../../utils/notify';

    const emit = defineEmits(['close', 'created']);

    const isLoading = ref(false);
    const modalOpen = ref(true);

    const formErrors = ref(null);
    const errorMessage = ref(null);
    const formData = ref(null);

    onMounted(() => {
        formData.value = {
            name: '',
            type: 'ceremony',
            date_unknown: false,
            date: '',
            duration: null,
            location_id: store.state.locations.length === 1 ? store.state.locations[0].id : null,
            state_id: STATE.OPEN,
            attendees: [
                {
                    name: '',
                    email: '',
                    send_invite: true,
                },
            ],
        };
    });

    async function createCeremony() {
        isLoading.value = true;
        formErrors.value = null;
        errorMessage.value = null;

        try {
            const ceremony = await ipcCall(IpcCall.CreateCeremony, {
                data: formData.value,
            });

            emit('created', ceremony);
            notifySuccess(i18n.t('ceremony.ceremony_created', { type: ceremony.translated_type }))
        } catch (exception) {
            console.error(exception);

            if (exception?.response) {
                switch (exception.response?.status) {
                    case 422:
                        formErrors.value = exception.response.data.errors;
                        return;
                }
            }

            errorMessage.value = i18n.t('ceremony.cant_create_ceremony');
        } finally {
            isLoading.value = false;
        }
    }

    function close() {
        emit('close');
    }
</script>
